import { motion } from "framer-motion";
import styles from "../styles/index";
import { fadeIn, staggerContainer } from "../utils/motion";
import { useTranslation } from "react-i18next";
import persianArtImg from "../public/Part1.png";
import { TitleText, TypingText } from "../components/customText";
const PersianArchitecture = () => {
  const { t } = useTranslation();
  return (
    <section className={`${styles.paddings}`}>
      <motion.div
        variants={staggerContainer}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.25 }}
        className={`${styles.innerWidth} mx-auto flex flex-col`}
      >
        <TypingText title={`${t("persianArt")}`} textStyles={"text-center"} />
        <TitleText
          title={`${t("PersianArchitecture")}`}
          textStyles={"text-center"}
        />
        <motion.div
          variants={fadeIn("up", "tween", 0.3, 1)}
          viewport={{ once: true, amount: 0.25 }}
          className="relative mt-[68px] flex justify-center rounded-lg  "
        >
          <img
            src={persianArtImg}
            alt=""
            className=" rounded-lg  w-[100%] lg:w-[90%]"
          />
        </motion.div>
      </motion.div>
    </section>
  );
};

export default PersianArchitecture;
